(function () {
  'use strict';

  function initTpReviewsCarousel() {
    var TP_REVIEWS_DEBUG = false;
    function tpReviewsLog() {
      if (!TP_REVIEWS_DEBUG || typeof console === 'undefined' || !console.log) return;
      var args = Array.prototype.slice.call(arguments);
      args.unshift('[tp-reviews]');
      console.log.apply(console, args);
    }

    var section =
      document.querySelector('[data-section="father-day-tp-reviews"] .tp-reviews') ||
      document.querySelector('.tp-reviews');
    if (!section) {
      tpReviewsLog('section not found');
      return;
    }

    var viewport = section.querySelector('.tp-reviews-carousel__viewport');
    var track = section.querySelector('.tp-reviews-carousel__track');
    var prevBtn = section.querySelector('.tp-reviews-carousel__arrow--prev');
    var nextBtn = section.querySelector('.tp-reviews-carousel__arrow--next');
    var progressFill = section.querySelector('.tp-reviews-carousel__progress-fill');
    if (!viewport || !track || !prevBtn || !nextBtn) {
      tpReviewsLog('missing required element', {
        viewport: !!viewport,
        track: !!track,
        prevBtn: !!prevBtn,
        nextBtn: !!nextBtn,
        progressFill: !!progressFill
      });
      return;
    }

    var cards = track.querySelectorAll('.tp-reviews-carousel__card');
    var totalCards = cards.length;
    if (totalCards === 0) {
      tpReviewsLog('no cards found');
      return;
    }
    tpReviewsLog('init', { totalCards: totalCards });

    var currentIndex = 0;
    var gap = 0;
    var step = 0;
    var maxIndex = 0;

    function updateStep() {
      if (cards[0]) {
        var computedTrackStyle = window.getComputedStyle(track);
        var rawGap = parseFloat(computedTrackStyle.columnGap || computedTrackStyle.gap || '0');
        gap = isFinite(rawGap) ? rawGap : 0;
        var w = cards[0].getBoundingClientRect().width;
        if (!w || !isFinite(w)) {
          w = cards[0].offsetWidth;
        }
        step = (w || 1) + gap;
        var viewportWidth = viewport.getBoundingClientRect().width || viewport.offsetWidth;
        var visibleCount = Math.max(1, Math.floor((viewportWidth + gap) / Math.max(step, 1)));
        maxIndex = Math.max(0, totalCards - visibleCount);
        if (currentIndex > maxIndex) {
          currentIndex = maxIndex;
        }
        tpReviewsLog('updateStep', {
          cardWidth: w,
          gap: gap,
          step: step,
          viewportWidth: viewportWidth,
          visibleCount: visibleCount,
          maxIndex: maxIndex,
          currentIndex: currentIndex
        });
      }
    }

    function updateProgress() {
      if (!progressFill) return;
      /* Match sections/quiz-reviews-carousel-quiz.liquid: steps = slide positions (maxIndex + 1). */
      var totalSteps = maxIndex <= 0 ? 1 : maxIndex + 1;
      var percentage = totalSteps <= 1 ? 100 : ((currentIndex + 1) / totalSteps) * 100;
      if (!isFinite(percentage)) {
        percentage = 100;
      }
      progressFill.style.width = percentage + '%';
      tpReviewsLog('updateProgress', {
        totalSteps: totalSteps,
        maxIndex: maxIndex,
        currentIndex: currentIndex,
        percentage: percentage,
        appliedWidth: progressFill.style.width
      });
    }

    function applyTransform() {
      updateStep();
      var offset = -currentIndex * step;
      track.style.transition = '';
      track.style.transform = 'translate3d(' + offset + 'px, 0, 0)';
      updateProgress();
      tpReviewsLog('applyTransform', {
        currentIndex: currentIndex,
        step: step,
        offset: offset,
        transform: track.style.transform
      });
    }

    function goNext() {
      tpReviewsLog('goNext (before)', { currentIndex: currentIndex, maxIndex: maxIndex });
      if (currentIndex < maxIndex) {
        currentIndex++;
      } else {
        currentIndex = 0;
      }
      tpReviewsLog('goNext (after)', { currentIndex: currentIndex, maxIndex: maxIndex });
      applyTransform();
    }

    function goPrev() {
      tpReviewsLog('goPrev (before)', { currentIndex: currentIndex, maxIndex: maxIndex });
      if (currentIndex > 0) {
        currentIndex--;
      } else {
        currentIndex = maxIndex;
      }
      tpReviewsLog('goPrev (after)', { currentIndex: currentIndex, maxIndex: maxIndex });
      applyTransform();
    }

    function dragBaseOffset() {
      updateStep();
      return -currentIndex * step;
    }

    function setTrackPx(px) {
      track.style.transform = 'translate3d(' + px + 'px, 0, 0)';
    }

    var swipe = { active: false, startX: 0, dx: 0, pointerId: null };

    function swipePointerEnd() {
      if (!swipe.active) return;
      swipe.active = false;
      if (viewport.releasePointerCapture && swipe.pointerId != null) {
        try { viewport.releasePointerCapture(swipe.pointerId); } catch (err) {}
      }
      swipe.pointerId = null;
      track.style.transition = '';
      updateStep();
      var thr = Math.max(40, Math.min(80, (step || 1) * 0.2));
      if (swipe.dx <= -thr) {
        goNext();
      } else if (swipe.dx >= thr) {
        goPrev();
      } else {
        applyTransform();
      }
      swipe.dx = 0;
    }

    function onSwipePointerDown(e) {
      if (swipe.active) return;
      if (typeof e.button === 'number' && e.button !== 0) return;
      swipe.active = true;
      swipe.startX = e.clientX;
      swipe.dx = 0;
      swipe.pointerId = e.pointerId != null ? e.pointerId : null;
      track.style.transition = 'none';
      if (viewport.setPointerCapture && swipe.pointerId != null) {
        try { viewport.setPointerCapture(swipe.pointerId); } catch (err) {}
      }
    }

    function onSwipePointerMove(e) {
      if (!swipe.active) return;
      swipe.dx = e.clientX - swipe.startX;
      setTrackPx(dragBaseOffset() + swipe.dx);
    }

    function onSwipeTouchStart(e) {
      if (swipe.active) return;
      if (!e.touches || !e.touches[0]) return;
      swipe.active = true;
      swipe.pointerId = null;
      swipe.startX = e.touches[0].clientX;
      swipe.dx = 0;
      track.style.transition = 'none';
    }

    function onSwipeTouchMove(e) {
      if (!swipe.active || !e.touches[0]) return;
      swipe.dx = e.touches[0].clientX - swipe.startX;
      setTrackPx(dragBaseOffset() + swipe.dx);
    }

    function onSwipeTouchEnd() {
      if (!swipe.active) return;
      swipe.active = false;
      track.style.transition = '';
      updateStep();
      var thr = Math.max(40, Math.min(80, (step || 1) * 0.2));
      if (swipe.dx <= -thr) {
        goNext();
      } else if (swipe.dx >= thr) {
        goPrev();
      } else {
        applyTransform();
      }
      swipe.dx = 0;
    }

    if (window.PointerEvent) {
      viewport.addEventListener('pointerdown', onSwipePointerDown);
      viewport.addEventListener('pointermove', onSwipePointerMove);
      viewport.addEventListener('pointerup', swipePointerEnd);
      viewport.addEventListener('pointercancel', swipePointerEnd);
    } else {
      viewport.addEventListener('touchstart', onSwipeTouchStart, { passive: true });
      viewport.addEventListener('touchmove', onSwipeTouchMove, { passive: true });
      viewport.addEventListener('touchend', onSwipeTouchEnd);
      viewport.addEventListener('touchcancel', onSwipeTouchEnd);
    }

    prevBtn.addEventListener('click', function () {
      tpReviewsLog('prev arrow clicked');
      goPrev();
    });
    nextBtn.addEventListener('click', function () {
      tpReviewsLog('next arrow clicked');
      goNext();
    });

    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(function () {
        applyTransform();
      });
      ro.observe(viewport);
    }
    window.addEventListener('resize', applyTransform);

    // Re-init when the taste-profile-page--loading class is removed
    // (quiz JS reveals the section after async data load, at which point
    //  getBoundingClientRect returns real values for the first time)
    var pageRoot = document.querySelector('.taste-profile-page');
    if (pageRoot && typeof MutationObserver !== 'undefined') {
      var mo = new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          if (m.attributeName === 'class' && !pageRoot.classList.contains('taste-profile-page--loading')) {
            mo.disconnect();
            requestAnimationFrame(function () {
              applyTransform();
            });
          }
        });
      });
      mo.observe(pageRoot, { attributes: true, attributeFilter: ['class'] });
    }

    applyTransform();
    requestAnimationFrame(function () {
      applyTransform();
    });
    tpReviewsLog('initialized complete');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTpReviewsCarousel);
  } else {
    initTpReviewsCarousel();
  }
})();
